module.exports = __webpack_public_path__ + "media/images/sns/x_icon_black-c019bd434e5489eb40e386b60cf045c9.png";